import { Injectable } from '@angular/core';
import { AuthBaseService } from '@core/auth/auth.base.service';

@Injectable({
  providedIn: 'root'
})
export class AuthProdService extends AuthBaseService {
  public authenticate(provider: string): void {
    this.redirect(`/oauth2/authorization/${provider.toLowerCase()}`);
  }
}
